import { useQuery } from "@tanstack/react-query";
import { getAssetFaultsCount, getAssetFaultsSearch } from "../api/asset-faults.service";
export const useAssetFaultsSearchQuery = (requestBody, options) => {
    return useQuery({
        enabled: options?.enabled ?? true,
        queryFn: () => getAssetFaultsSearch(requestBody, undefined, options?.sortBy, options?.orderBy, options?.limit, options?.skip),
        queryKey: [
            "assetFaultsSearch",
            requestBody,
            options?.sortBy,
            options?.orderBy,
            options?.limit,
            options?.skip,
            options?.sortKey
        ]
    });
};
export const useAssetFaultsCountQuery = (requestBody, options) => {
    return useQuery({
        enabled: options?.enabled ?? true,
        queryFn: () => getAssetFaultsCount(undefined, requestBody),
        queryKey: ["assetFaultsCount", requestBody]
    });
};
